import React, { useRef } from 'react';
import management_staff_icon from '../icons/management-staff.svg';
import ManagementStaffModal, { ManagementStaffModalRef } from './ManagementStaffModal';

const ButtonManagementStaff = () => {
  const managementStaffModalRef = useRef<ManagementStaffModalRef>(null);

  return (
    <>
      <button className='btn' onClick={() => managementStaffModalRef.current?.open()}>
        <img src={management_staff_icon} alt='management_staff_icon' className='icon-action' />
        <span>Assistant Login</span>
      </button>
      <ManagementStaffModal ref={managementStaffModalRef} />
    </>
  );
};

export default ButtonManagementStaff;
